import { render, staticRenderFns } from "./EcommerceStatistics.vue?vue&type=template&id=498c812f&"
import script from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
export * from "./EcommerceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498c812f')) {
      api.createRecord('498c812f', component.options)
    } else {
      api.reload('498c812f', component.options)
    }
    module.hot.accept("./EcommerceStatistics.vue?vue&type=template&id=498c812f&", function () {
      api.rerender('498c812f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/EcommerceStatistics.vue"
export default component.exports